import React from 'react';
import { Target, Settings, Upload, Plus } from 'lucide-react';
import './CycleTabs.css';

export interface Tab {
    _id: string;
    name: string;
    order: number;
    deckIds: string[];
    decks: any[];
}
// teste
interface CycleTabsProps {
    tabs: Tab[];
    activeTabId: string | null;
    onTabChange: (tabId: string) => void;
    isAdmin: boolean;
    hasTabs: boolean;
    // Estudo personalizado
    showStudyMode: boolean;
    onStudyToggle: () => void;
    // Admin actions
    onOpenTabManager: () => void;
    onCreateDeck: () => void;
    onImportDeck: () => void;
}

const CycleTabs: React.FC<CycleTabsProps> = ({
    tabs,
    activeTabId,
    onTabChange,
    isAdmin,
    hasTabs,
    showStudyMode,
    onStudyToggle,
    onOpenTabManager,
    onCreateDeck,
    onImportDeck,
}) => {
    const sorted = [...tabs].sort((a, b) => a.order - b.order);

    // COM ABAS — layout completo
    if (hasTabs) {
        return (
            <div className="ct-wrapper">
                <div className="ct-inner">
                    {/* Abas dinâmicas à esquerda */}
                    <div className="ct-tabs-left">
                        {sorted.map(tab => (
                            <button
                                key={tab._id}
                                className={`ct-tab ${activeTabId === tab._id ? 'ct-tab--active' : ''}`}
                                onClick={() => onTabChange(tab._id)}
                            >
                                <span className="ct-tab-name">{tab.name}</span>
                                <span className="ct-tab-count">
                                    {tab.decks?.length || 0} deck{(tab.decks?.length || 0) !== 1 ? 's' : ''}
                                </span>
                            </button>
                        ))}


                    </div>

                    {/* Direita — Estudo Personalizado + admin actions */}
                    <div className="ct-tabs-right">
                        {/* Estudo Personalizado */}
                        <button
                            className={`ct-tab ct-tab--study ${showStudyMode ? 'ct-tab--active' : ''}`}
                            onClick={onStudyToggle}
                        >
                            <Target size={14} className="ct-tab-icon" />
                            <span className="ct-tab-name">Estudo Personalizado</span>
                        </button>

                        {/* Aba admin — mesmo estilo, só para admin */}
                        {isAdmin && (
                            <div className="ct-tab ct-tab--admin">
                                <button
                                    className="ct-admin-action-btn"
                                    onClick={onCreateDeck}
                                    title="Criar Deck"
                                >
                                    <Plus size={15} />
                                </button>
                                <button
                                    className="ct-admin-action-btn"
                                    onClick={onImportDeck}
                                    title="Importar Deck"
                                >
                                    <Upload size={15} />
                                </button>
                                <button
                                    className="ct-admin-action-btn"
                                    onClick={onOpenTabManager}
                                    title="Gerenciar Abas"
                                >
                                    <Settings size={15} />
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    // SEM ABAS — sem barra de abas, controles ficam no header
    return null;
};

export default CycleTabs;